import { Tooltip } from 'antd';
import type { TooltipPlacement } from 'antd/es/tooltip';
import classNames from 'classnames';

import styles from './index.less';

interface IProps {
  show?: boolean;
  className?: string;
  arrow?: boolean;
  children?: React.ReactNode;
  open?: boolean;
  placement?: TooltipPlacement;
  overlayClassName?: string;
  destroyTooltipOnHide?: boolean;
  title?: React.ReactNode;
  getPopupContainer?: (node: HTMLElement) => HTMLElement;
}
function PATooltip(props: IProps): JSX.Element {
  const { children, show = true, overlayClassName, ...rest } = props;

  if (!show) {
    return <>{children}</>;
  }

  return (
    <Tooltip overlayClassName={classNames(styles.overlayClassName, overlayClassName)} {...rest}>
      {children}
    </Tooltip>
  );
}
export default PATooltip;
